import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketData: null,
  marketImpressions: null,
  status: 'idle',
  error: null,
};

const dataSlice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    setMarketData: (state, action) => {
      state.marketData = action.payload;
      state.status = 'succeeded';
    },
    setMarketImpressionsData: (state, action) => {
      state.marketImpressions = action.payload; // Store the second API data
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setMarketData, setMarketImpressionsData, setError, setLoading } = dataSlice.actions;
export default dataSlice.reducer;
